import { Typography } from "@material-ui/core";
import React from "react";
import { FormattedMessage } from "react-intl";
import type { Property } from "../property-type";

type PropertyWithUnitMeta = Property & {
  meta: {
    units: { title?: string; value?: string }[];
  };
};

type UnitResultProps = {
  property: PropertyWithUnitMeta;
};

const UnitResult = (props: UnitResultProps) => {
  const { property } = props;
  const { meta, orderedProperties } = property;
  const { units } = meta;

  const value = orderedProperties.find((p) => p.name === "value")?.value;

  if (!value) {
    return (
      <Typography variant="body1">
        <FormattedMessage
          id="investigation.result.unit.empty"
          defaultMessage="-"
        />
      </Typography>
    );
  }

  let unitTitle = "";
  const unitDetails = orderedProperties.find((p) => p.name === "unit");

  if (unitDetails) {
    const unitValue = unitDetails.value
      ? unitDetails.value
      : unitDetails.default;
    unitTitle = units?.find((u) => u.value === unitValue)?.title ?? "";
  }

  const display = `${value} ${unitTitle}`;
  return <Typography variant="body1">{display}</Typography>;
};

export default React.memo(UnitResult);
